import { render, staticRenderFns } from "./Product500Page.vue?vue&type=template&id=2f3a42c4"
import script from "./Product500Page.vue?vue&type=script&lang=js"
export * from "./Product500Page.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports